import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSecondrySale } from "store/actions";
import ExploreCard from "Pages/Home/Currentauction";
import { Container, Button } from "react-bootstrap";

import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    EmailShareButton,
    EmailIcon,

} from "react-share";
export default function Share(props) {
    return (
        <>
            <FacebookShareButton url={props.shareUrl}>
                <FacebookIcon />
            </FacebookShareButton >
            <TwitterShareButton url={props.shareUrl}>
                <TwitterIcon />
            </TwitterShareButton>
            <EmailShareButton url={props.shareUrl}>
                <EmailIcon />
            </EmailShareButton>
        </>
    )

}